module.exports = __webpack_public_path__ + "static/scroll-518586494ca03ba4922f43646c988e16.mp4";